const prefix = <const T extends string>(id: T) => `MortgageEarn.${id}` as const

export const Config = {
  Users: {
    General: {
      Email: 'ebc4ad6f-bd40-4ad9-ada4-e6b44b6c28e8@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Mortgage Earn General',
      PhoneNumber: '(892) 123-8912',
    },
    Statsig: {
      Email: 'b7299d19-6281-41e1-845e-f8300bbe7296@mailslurp.biz',
      FirstName: 'End To End Testing',
      LastName: 'Mortgage Earn Statsig',
      PhoneNumber: '(892) 123-8913',
    },
  },
  Ids: {
    View: {
      EarnOnMortgageDocumentUpload: prefix('View.EarnOnMortgageDocumentUpload'),
      EarnOnMortgageIndex: prefix('View.EarnOnMortgageIndex'),
    },
    Press: {
      CheckListItem: prefix('Press.CheckListItem'),
      IndexBack: prefix('Press.IndexBack'),
      UpdateMortgageAmount: prefix('Press.UpdateMortgageAmount'),
      Update: prefix('Press.Update'),
      UploadDocument: prefix('Press.UploadDocument'),
      UploadBack: prefix('Press.UploadBack'),
      AddDocument: prefix('Press.AddDocument'),
      ContinueToUpload: prefix('Press.ContinueToUpload'),
    },
    Text: {
      IsCardAppAmount: prefix('Text.IsCardAppAmount'),
    },
    Input: {
      MonthlyHousingPayment: prefix('Input.MonthlyHousingPayment'),
    },
  },
} as const
